import { SurgeonLayout } from '@/components/surgeon/SurgeonLayout';
import { IntraOpEvidenceAnalyzer } from '@/components/surgeon/IntraOpEvidenceAnalyzer';

export default function IntraOpEvidencePage() {
  return (
    <SurgeonLayout>
      <div className="w-full">
        <IntraOpEvidenceAnalyzer />
      </div>
    </SurgeonLayout>
  );
}
